export const monthMapper = (monthIndex) => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]
  return months[monthIndex - 1]
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/month-mapper/index.js